import * as c from './constants';

export const initialState = {
  loading: false,
  data: [],
};

const addressReducer = (state = initialState, action) => {
  switch (action.type) {
    case c.COURIER_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case c.COURIERS_FULFILLED:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default addressReducer;
